"use strict";
/* tslint:disable:no-console */
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = void 0;
function padNumber(str) {
    str = '00' + str;
    return str.substring(str.length - 2, str.length);
}
var log = function (option) {
    console.log.apply(console, __spreadArray([padNumber(option.time.getHours()) + ":" + padNumber(option.time.getMinutes()) + ":" + padNumber(option.time.getSeconds())], option.text));
};
exports.log = log;
